"use strict";

$.fn.InitBaseDocumentaireModal = function () {
    var $target = $(this);
    $(document).on("change", "div.row-type input:radio", function () {
        var $this = $(this);
        $.map($target.find("div.row[data-type]"), function (e) {
            var $e = $(e);
            if ($e.data("type") === $this.val()) {
                $e.removeClass("d-none");
            } else {
                $e.addClass("d-none");
            }
        });
    });
    return $target;
};
$.fn.CheckFormValidity = function () {
    var $this = $(this),
        $type = $this.find("div.row-type"),
        inputLibelleValue = $this.find("input#Libelle").val();
    if ($type) {
        var $radioChecked = $type.find("input:radio:checked"),
            $rowChecked = $this.find("div.row[data-type=" + $radioChecked.val() + "]"),
            inputValue = $rowChecked.find("input").val();
        return $rowChecked.is(":visible") && inputValue && inputLibelleValue;
    } else {
        var $url = $this.find("input#Url"),
            inputUrlValue = $url.val();
        return (!$url.is(":visible") || inputLibelleValue) && inputLibelleValue;
    }
};
$.fn.OnDoneBd = function (data) {
    $("li.base-docu-menu[data=" + data.id + "]").trigger("click");
};
$(function () {
    var getCurrentCategorie = function getCurrentCategorie() {
        return $("input:hidden#categorie").val() || $("input:hidden#currentCategorie").val() || 0;
    },
        loadCategorie = function loadCategorie(id) {
        var $content = $("div.col-base-docu-content");
        $content.load($content.data("url") + "/" + id + "?currentCategorie=" + getCurrentCategorie(), function (data) {
            var $Icon = $("i.doc-icon");
            $Icon.hide().each(function () {
                var $i = $(this);
                $i.addClass("fa-" + $.getCssForExtension($i.data("ext")));
            }).show();
            var currentCat = parseInt(getCurrentCategorie());
            $("li.base-docu-menu").each(function () {
                var $this = $(this);
                if ($this.data("id") === currentCat) {
                    if (!$this.hasClass("cat-selected")) {
                        $this.addClass("cat-selected");
                    }
                    var $parents = $this.parents("ul");
                    $parents.each(function () {
                        var $parent = $(this);
                        if (!$parent.is(":visible")) {
                            $parent.parent().find(">i.tree-indicator").click();
                        }
                    });
                    return true;
                }
                $this.removeClass("cat-selected");
            });
            $.addOrRemoveOverflow();
        });
    };
    $(document).on("click", ".lbl-base-docu-cat, i.folder-icon", function () {
        loadCategorie($(this).data("id"));
    });
    loadCategorie($("input:hidden#currentCategorie").val());
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/BaseDocumentaire/index.ts
// module id = 606
// module chunks = 0